import React, { useState, useEffect, Fragment } from "react";
import { Button } from "../../common";
import Hints from "./Hints";
import { useWindowDimensions } from "../../helpers/hooks";
import { isSmallerThanDesktop } from "../../helpers";
import FileDropzoneNew from "../../common/FileDropzoneNew";
import * as style from "./styles.module.scss";

const StudentDocuments = ({
  courseCompleted,
  document,
  setStep,
  setPreviousStep,
  frontOfIdFile,
  backOfIdFile,
  handleChange,
  hints,
}) => {
  const [backToHints, setBackToHints] = useState(false);
  const [isValidFileTypeFront, setIsValidFileTypeFront] = useState(true);
  const [isValidFileTypeBack, setIsValidFileTypeBack] = useState(true);

  const { width } = useWindowDimensions();
  const isSmallerThanLarge = isSmallerThanDesktop(width);

  const onImageUpload = (key, value) => {
    handleChange(key, value);
    if (isSmallerThanLarge) {
      if (key === "frontOfIdFile") {
        if (frontOfIdFile) setIsValidFileTypeFront(true);
      }
      if (key === "backOfIdFile" && backOfIdFile) {
        setIsValidFileTypeBack(true);
      }
      if (backToHints) {
        setBackToHints(false);
      }
    }
  };

  const handleBack = () => {
    return () => {
      setStep(0);
    };
  };

  const handleSubmit = () => {
    setStep(1);
    setPreviousStep("student");
  };

  useEffect(() => {
    if (isSmallerThanLarge && frontOfIdFile && backOfIdFile) {
      handleChange("backOfIdFile", null);
    }
  }, [isValidFileTypeFront]);

  useEffect(() => {
    if (!document) {
      setStep(0);
    }
  }, []);

  return (
    <Fragment>
      <div>
        <div className="mb-2">{document.title}</div>
        <div className="mb-4">
          <div className="d-block mb-1">{document.subtitles[0]}</div>
          <FileDropzoneNew
            acceptedFileTypes=".jpg,.jpeg,.png"
            handleChange={onImageUpload}
            fileStateName="frontOfIdFile"
            fileParsedToString={frontOfIdFile}
            handleInvalidType={() => setIsValidFileTypeFront(false)}
            isFileValid={isValidFileTypeFront}
            wrongFileTypeHint="Your image needs to be provided as a JPEG or PNG file."
          />
        </div>
        <div className="mb-4">
          <div className="d-block mb-1">{document.subtitles[1]}</div>
          <FileDropzoneNew
            acceptedFileTypes=".jpg,.jpeg,.png"
            handleChange={onImageUpload}
            fileStateName="backOfIdFile"
            fileParsedToString={backOfIdFile}
            handleInvalidType={() => setIsValidFileTypeBack(false)}
            isFileValid={isValidFileTypeBack}
            wrongFileTypeHint="Your image needs to be provided as a JPEG or PNG file."
          />
        </div>
        <div className="mb-4">
          If you do not have these documents to upload, please source the
          documents and then come back to the Right to Work section to upload
          and carry on your check.
        </div>
        <div className="mb-2">
          <Hints hints={hints} />
        </div>
      </div>
      <div className={`mt-4 mt-lg-auto mb-2 ${style.actions}`}>
        <Button
          classes="btn btn-outline-info text-dark mr-1"
          onClick={handleBack()}
        >
          Back
        </Button>

        <Button
          classes="btn btn-primary btn-block"
          onClick={handleSubmit}
          disabled={!frontOfIdFile || (courseCompleted && !backOfIdFile)}
        >
          Next
        </Button>
      </div>
    </Fragment>
  );
};

export default StudentDocuments;
